<template>
  <div class="answer-container">
    <question
      v-show="!showAnalysis"
      :curQuestion="curQuestion"
      :curQuestionIndex="curQuestionIndex"
      :qList="qList"
      @optionsChange="optionsChange"
      @btntopre="btnToPre"
      @btntonext="btnToNext"
    ></question>
    <Aquestion
      v-show="showAnalysis"
      :curQuestion="curQuestion"
      :curQuestionIndex="curQuestionIndex"
      :curAnalysis="curAnalysis"
      @btntopre="btnToPre"
      @btntonext="btnToNext"
    ></Aquestion>
    <qList
      v-on:qListClick="qListClick"
      :qList="qList"
      :showAnalysis="showAnalysis"
      @toSub="analysisChange"
    ></qList>
  </div>
</template>

<script>
  import {getUrlKey} from '../../untils/common.js'
  import question from './children/question.vue'
  import Aquestion from './children/Aquestion.vue'
  import qList from './children/qList.vue'
  import {ApiGetSQList, ApiGetPQuestion, ApiSavePractice, ApiGetAnalysis} from '../../net/exam/index.js'
  export default {
    data: function () {
      return {
        uid: 0,
        showAnalysis: false,
        PopupShow: false, //题目列表显示
        curQuestionIndex: 0, // 当前题目在列表中的位置
        ExerciseAnalysisShow: false, // 答题解析
        practiceId: 0, // 练习试卷id
        practiceName: '',
        error: 0, // 错误的个数
        correct: 0, // 正确的个数
        qList: [],
        curQuestion: {
          questionId: 0,
          questionType: 3,
          answerStatus: 0,
          options: [], // 当前题的选项
          title: '', // 当前题的题干
          trueAnswer: '', // 正确答案
          studentAnswer: '', // 学生的答案
          analysis: '' // 答题解析
        },
        curStudentAnswer: '',
        curAnalysis: '',
      }
    },
    computed:{
      questionId: function () {
        return this.qList[this.curQuestionIndex].questionId
      },
      is_checked: function () {
        return  this.curQuestion.options.some(item=>{
          return item.checked
        })

      }
    },
    components: {question, qList, Aquestion},
    methods: {
      getQList: function () {
        const params = {
          categoryId: this.practiceId,
          uid: this.uid
        }
        ApiGetSQList(params).then(res=>{
          if (res.code == 200) {
            this.qList = res.value.questions
            this.correct = res.value.correct
            this.error = res.value.error
            this.practiceName = res.value.practiceName
            this.getQuestion()
          }

        }).catch(err=>{

        })
      },
      getQuestion: function () {
        const params = {
          practiceId: 0,
          questionId: this.questionId,
          uid: this.uid
        }
        ApiGetPQuestion(params).then(res=>{
           if (res.code == 200) {
            // console.log('获取试题',res)
             const _options = this.handlOption(res)
             this.curQuestion = {...res.value, options: _options}
           }
        }).catch(err=>{

        })

      },
      handlOption: function (res) {
        let _options = []
        if (res.value.questionType == 3) {
          _options = [{option: '1', content: '正确', checked: false}, {option: '2', content: '错误', checked: false}]
        } else {
          _options = JSON.parse(res.value.options).map(item=>{
            let option = '', content = ''
            for (name in item) {
               option = name
               content = item[name]
            }
            return {option, content, checked: false}
          })
        }
        if (res.value.studentAnswer) {
          _options = _options.map(item=>{
            if (res.value.studentAnswer.indexOf(item['option']) != -1){
              return {...item, checked: true}
            }
            return {...item, checked: false}
          })
        }
        return _options
      },
      upData: function (studentAnswerArr, fn) {
        let state = 0
        studentAnswerArr = studentAnswerArr.map(item => {
          return item.option
        })
        this.curQuestion.studentAnswer = studentAnswerArr.join('')
        if (this.curQuestion.studentAnswer != '') {state = 1}
        if (this.curQuestion.studentAnswer == this.curQuestion.trueAnswer) {state = 2}
        const params = {
          uid: this.uid,
          practiceId: 0,
          questionId: this.questionId,
          studentAnswer: this.curQuestion.studentAnswer,
          state: state,
          random: 'fasdfasdfasdf',
          timeStamp: 15000000,
          sign: ''
        }
        ApiSavePractice(params).then(res=>{
          if (res.code == 200) {
            // this.getAnalysis()
            this.qList[this.curQuestionIndex].answerStatus = state
          }
          fn&&fn()
        }).catch(err=>{

        })

      },
      analysisChange: function () {
        if (this.showAnalysis) {
          this.showAnalysis = !this.showAnalysis
          return
        }
        let studentAnswerArr = this.curQuestion.options.filter(item=>{
          return item.checked == true
        })
        this.upData(studentAnswerArr, ()=>{
          this.getAnalysis()
          this.showAnalysis = !this.showAnalysis
        })

      },
      getAnalysis: function () {
        const params = {questionId: this.questionId}
        ApiGetAnalysis(params).then(res=>{
          if (res.code == 200) {
            this.curStudentAnswer = this.curQuestion.studentAnswer
            this.curAnalysis = this.curQuestion.analysis = res.value
           // console.log('this.curAnalysis', this.curAnalysis)
          }
        })
      },
      qListClick: function (index) {
        this.touchUpData(()=>{
          this.curQuestionIndex = index
          this.getQuestion()
        })
      },
      optionsChange: function (_options) {
        this.curQuestion.options = _options;
      },
      touchUpData: function (fn) {
        let studentAnswerArr = this.curQuestion.options.filter(item=>{
          return item.checked == true
        })
        this.upData(studentAnswerArr,()=>{
          fn&&fn()
        })
      },
      btnToPre: function () {
        if (this.curQuestionIndex <= 0) {
          this.$message.warning('已经是第一题了')
          return
        }
        this.touchUpData(()=>{
          this.curQuestionIndex --
          this.getQuestion()
        })

      },
      btnToNext: function () {
        if (this.curQuestionIndex >= this.qList.length - 1) {
          this.$message.warning('已经是最后一题了')
          return
        }
        this.touchUpData(()=>{
          this.curQuestionIndex ++
          this.getQuestion()
        })

      }
    },
    mounted: function () {
      this.practiceId = getUrlKey('eid',window.location.href) || 0
      this.getQList()
    }
  }
</script>

<style scoped>
.answer-container{
  width: 1140px;
  margin:0 auto;
  border-radius: 6px;
  margin-top: 24px;
  overflow: hidden;
  margin-bottom: 24px;
}
</style>



// WEBPACK FOOTER //
// src/components/SpecialEx/SpecialEx.vue